import type { Template } from "@/types";

export const PO_06_H4_V2: Template[] = [
    {
        id: "po-06-h4v2-01",
        name: "PO 01 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 63, y: 161, width: 549, height: 391, rotation: 0, imageRotation: 0 },
            { id: "2", x: 63, y: 560, width: 178, height: 111, rotation: 0, imageRotation: 0 },
            { id: "3", x: 249, y: 560, width: 178, height: 111, rotation: 0, imageRotation: 0 },
            { id: "4", x: 435, y: 560, width: 177, height: 111, rotation: 0, imageRotation: 0 },
            { id: "5", x: 707, y: 226, width: 263, height: 376, rotation: 0, imageRotation: 0 },
            { id: "6", x: 978, y: 226, width: 263, height: 376, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-02",
        name: "PO 02 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 63, y: 158, width: 549, height: 335, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 63, y: 501, width: 271, height: 168, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 501, width: 270, height: 168, rotation: 0, imageRotation: 0 },
            { id: "4", x: 784, y: 158, width: 367, height: 239, rotation: 0, imageRotation: 0 },
            { id: "5", x: 784, y: 405, width: 180, height: 263, rotation: 0, imageRotation: 0 },
            { id: "6", x: 972, y: 405, width: 179, height: 263, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-03",
        name: "PO 03 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 86, y: 159, width: 220, height: 320, rotation: 0, imageRotation: 0 },
            { id: "2", x: 86, y: 487, width: 131, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 225, y: 487, width: 339, height: 181, rotation: 0, imageRotation: 0 },          
            { id: "4", x: 314, y: 159, width: 250, height: 156, rotation: 0, imageRotation: 0 },
            { id: "5", x: 314, y: 323, width: 250, height: 156, rotation: 0, imageRotation: 0 },
            { id: "6", x: 709, y: 246, width: 528, height: 337, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h4v2-04",
        name: "PO 04 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 56, y: 247, width: 537, height: 333, rotation: 0, imageRotation: 0 },
            { id: "2", x: 702, y: 158, width: 271, height: 392, rotation: 0, imageRotation: 0 },
            { id: "3", x: 981, y: 158, width: 271, height: 392, rotation: 0, imageRotation: 0 },
            { id: "4", x: 702, y: 558, width: 178, height: 111, rotation: 0, imageRotation: 0 },
            { id: "5", x: 888, y: 558, width: 178, height: 111, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1074, y: 558, width: 178, height: 111, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-05",
        name: "PO 05 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 58, y: 168, width: 342, height: 492, rotation: 0, imageRotation: 0 },
            { id: "2", x: 408, y: 418, width: 191, height: 242, rotation: 0, imageRotation: 0 },
            { id: "3", x: 408, y: 168, width: 191, height: 117, rotation: 0, imageRotation: 0 },
            { id: "4", x: 408, y: 293, width: 191, height: 117, rotation: 0, imageRotation: 0 },
            { id: "5", x: 781, y: 168, width: 387, height: 242, rotation: 0, imageRotation: 0 },
            { id: "6", x: 781, y: 418, width: 387, height: 242, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-06",
        name: "PO 06 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_06.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 56, y: 246, width: 237, height: 335, rotation: 0, imageRotation: 0 },        
            { id: "2", x: 301, y: 246, width: 168, height: 107, rotation: 0, imageRotation: 0 },
            { id: "3", x: 301, y: 361, width: 168, height: 106, rotation: 0, imageRotation: 0 },
            { id: "4", x: 301, y: 475, width: 168, height: 106, rotation: 0, imageRotation: 0 },
            { id: "5", x: 477, y: 246, width: 236, height: 335, rotation: 0, imageRotation: 0 },
            { id: "6", x: 721, y: 246, width: 523, height: 335, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-07",
        name: "PO 07 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_07.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 66, y: 158, width: 706, height: 510, rotation: 0, imageRotation: 0 },
            { id: "2", x: 780, y: 158, width: 182, height: 251, rotation: 0, imageRotation: 0 },
            { id: "3", x: 780, y: 417, width: 182, height: 251, rotation: 0, imageRotation: 0 },
            { id: "4", x: 970, y: 158, width: 261, height: 165, rotation: 0, imageRotation: 0 },
            { id: "5", x: 970, y: 331, width: 261, height: 165, rotation: 0, imageRotation: 0 },
            { id: "6", x: 970, y: 504, width: 261, height: 164, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-08",
        name: "PO 08 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 193, width: 335, height: 217, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 418, width: 335, height: 216, rotation: 0, imageRotation: 0 },
            { id: "3", x: 343, y: 193, width: 335, height: 217, rotation: 0, imageRotation: 0 },
            { id: "4", x: 343, y: 418, width: 335, height: 216, rotation: 0, imageRotation: 0 },
            { id: "5", x: 686, y: 193, width: 302, height: 440, rotation: 0, imageRotation: 0 },
            { id: "6", x: 996, y: 193, width: 302, height: 440, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-09",
        name: "PO 09 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 66, y: 99, width: 227, height: 311, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 301, y: 99, width: 462, height: 311, rotation: 0, imageRotation: 0 },
            { id: "3", x: 771, y: 99, width: 462, height: 311, rotation: 0, imageRotation: 0 },     
            { id: "4", x: 66, y: 418, width: 462, height: 310, rotation: 0, imageRotation: 0 },
            { id: "5", x: 536, y: 418, width: 462, height: 310, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1006, y: 418, width: 227, height: 310, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-10",
        name: "PO 10 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_10.png",
        size: [1298, 827],
        style: {},
        slots: [          
            { id: "1", x: 61, y: 131, width: 442, height: 278, rotation: 0, imageRotation: 0 },
            { id: "2", x: 61, y: 417, width: 442, height: 278, rotation: 0, imageRotation: 0 },
            { id: "3", x: 511, y: 131, width: 323, height: 457, rotation: 0, imageRotation: 0 },
            { id: "4", x: 511, y: 596, width: 158, height: 99, rotation: 0, imageRotation: 0 },
            { id: "5", x: 677, y: 596, width: 157, height: 99, rotation: 0, imageRotation: 0 },          
            { id: "6", x: 842, y: 131, width: 393, height: 564, rotation: 0, imageRotation: 0 }
        ],
    }
];